import { useState, useCallback } from "react";
import { CryptoService } from "../utils/CryptoService";

export function useSecureFetch() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const secureFetch = useCallback(async (url, options = {}) => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await CryptoService.createSecureFetch()(url, options);
      setIsLoading(false);
      return result;
    } catch (err) {
      setError(err.message || "An error occurred during fetch");
      setIsLoading(false);
      throw err;
    }
  }, []);

  return { secureFetch, isLoading, error };
}